import React from 'react'

const PercentCell = ({ value, rag = false, ragLimits, valueIsSmaller = true }) => {
  let style = {}
  if (rag) {
    if (valueIsSmaller ? value <= parseInt(ragLimits.red) :  value >= parseInt(ragLimits.red)) {
      style.color = 'red'
    } else if (valueIsSmaller ? value <= parseInt(ragLimits.amber) : value >= parseInt(ragLimits.amber) ) {
      style.color = 'orange'
    } else {
      style.color = 'green'
    }
  }

  return <span style={style}>{value}%</span>
}

export default PercentCell
